import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/shared/data/data.service';

interface ServiceItem {
    id: string;
    icon: string;
    title: string;
    description: string;
    features: string[];
    status: number;
}

interface ApiResponse {
    data: {
        id: string;
        icon: string;
        title: string;
        description: string;
        features: string;
        status: number;
        created_by: number;
        updated_by: number | null;
        created_date: string;
        updated_date: string | null;
        is_deleted: number;
        is_deleted_by: number | null;
        is_deleted_date: string | null;
    }[];
    total_count: number;
    page: number;
    page_size: number;
    total_pages: number;
    status: number;
}

@Component({
    selector: 'app-services-page',
    templateUrl: './services-page.component.html',
    styleUrls: ['./services-page.component.scss']
})
export class ServicesPageComponent implements OnInit {

    services: ServiceItem[] = [];
    isLoading: boolean = true;
    hasError: boolean = false;

    constructor(
        private meta: Meta,
        private titleService: Title,
        private http: HttpClient, private data : DataService,
    ) { }

    ngOnInit(): void {
        this.titleService.setTitle('Fire Protection Services in Qatar | Union Fire Protection');
        this.meta.updateTag({
            name: 'description',
            content: 'Comprehensive fire protection services in Qatar including fire alarm systems, sprinkler systems, fire suppression, and safety consulting.'
        });

        this.fetchServices();
    }

    private fetchServices(): void {
        this.isLoading = true;
        this.hasError = false;

        this.http.post<ApiResponse>(this.data.base_url+'get_webservice_data/', {}).subscribe({
            next: (response) => {
                if (response?.status === 1 && response?.data) {
                    this.services = response.data
                        .filter(item => item.is_deleted === 0)
                        .map(item => ({
                            id: item.id,
                            icon: item.icon || 'bx-shield',  // fallback icon
                            title: item.title,
                            description: item.description,
                            features: this.parseFeatures(item.features),
                            status: item.status
                        }));
                }
                this.isLoading = false;
            },
            error: (err) => {
                console.error('Failed to fetch services:', err);
                this.hasError = true;
                this.isLoading = false;
            }
        });
    }

    /**
     * Handles two formats from API:
     * 1. JSON array string: '["feature1","feature2"]'
     * 2. Comma-separated string: "feature1,\nfeature2,\nfeature3"
     */
    private parseFeatures(features: string): string[] {
        if (!features) return [];

        // Try JSON array first
        try {
            const parsed = JSON.parse(features);
            if (Array.isArray(parsed)) {
                return parsed.map(f => f.trim()).filter(f => f.length > 0);
            }
        } catch {
            // Not JSON — fall through to comma split
        }

        // Comma-separated string fallback
        return features
            .split(',')
            .map(f => f.trim())
            .filter(f => f.length > 0);
    }

    pageTitle = [
        {
            bgImage: 'assets/img/services-banner.jpg',
            title: 'Our Fire Protection Services'
        }
    ]

    servicesContent = [
        {
            subTitle: "OUR SERVICES",
            title: "Complete Fire Safety Solutions",
            paragraph: "Union Fire Protection offers a comprehensive range of fire safety services designed to protect lives, property, and businesses across Qatar. Our expert team delivers customized solutions tailored to your specific needs."
        }
    ]
}